import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * React Router does not scroll to top on navigation. Without this, visiting a
 * new route from a scrolled page (e.g. footer → About Us) keeps the old Y offset.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0)
      return
    }
    // Wait for React to render the target section before scrolling
    const id = hash.slice(1)
    const timer = setTimeout(() => {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }, 100)
    return () => clearTimeout(timer)
  }, [pathname, hash])

  return null
}
